import styled from 'styled-components';

export const StyledMeetingForm = styled.div`
	margin-top: 24px;
`;
